import { z } from 'zod'

export const informationsPassengersSearchSchema = z.object({
  adults: z.number().default(0),
  babies: z.number().default(0),
  infants: z.number().default(0),
  seniors: z.number().default(0),
  youngsters: z.number().default(0),
})

export const informationsSearchSchema = z.object({
  departureDate: z.string(),
  destination: z.string(),
  journeyKeys: z.array(z.string()),
  offerKey: z.string(),
  origin: z.string(),
  passengers: informationsPassengersSearchSchema,
  returnDate: z.string().optional(),
  transactionKey: z.string(),
  tripType: z.enum(['one-way', 'round-trip', 'multi-destination']),
})

export type InformationsSearchParams = z.infer<typeof informationsSearchSchema>
